import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';

import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetLocationQuery } from '@app/core/service/cpms-bo-location.service';
import { cpmsBoLocationSlice } from '@app/core/service/cpms-bo-location.slice';

export interface LocationFilterStateControllerProps {
  value: GatewayLocationModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const LocationFilterStateController = ({
  value,
  onRemove,
}: LocationFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const location = useAppSelector((state) =>
    cpmsBoLocationSlice.selectors.selectById(state, value),
  );

  const { data: locationApiData } = useCpmsBoGetLocationQuery(value, {
    skip: !!location,
  });

  const locationName = location?.name ?? locationApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="location" label={locationName} onRemove={onRemove} />
  );
};
